(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-learn-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ai-learn-slider')) {
    customElements.define(
      'ai-learn-slider',
      class AiLearnSlider extends HTMLElement {
        connectedCallback() {
          if (this.isInitialized) return;

          this.track = this.querySelector('.hiw-learn__track');
          this.controls = this.querySelector('.hiw-learn__controls');
          this.previousButton = this.querySelector('[data-direction="previous"]');
          this.nextButton = this.querySelector('[data-direction="next"]');

          if (!this.track || !this.controls || !this.previousButton || !this.nextButton) return;

          this.isInitialized = true;
          this.updateControls = this.updateControls.bind(this);
          this.handlePrevious = () => this.move(-1);
          this.handleNext = () => this.move(1);

          this.track.addEventListener('scroll', this.updateControls, { passive: true });
          this.previousButton.addEventListener('click', this.handlePrevious);
          this.nextButton.addEventListener('click', this.handleNext);

          this.resizeObserver = new ResizeObserver(this.updateControls);
          this.resizeObserver.observe(this.track);
          Array.from(this.track.children).forEach((slide) => this.resizeObserver.observe(slide));

          requestAnimationFrame(this.updateControls);
        }

        disconnectedCallback() {
          if (!this.isInitialized) return;

          this.track.removeEventListener('scroll', this.updateControls);
          this.previousButton.removeEventListener('click', this.handlePrevious);
          this.nextButton.removeEventListener('click', this.handleNext);
          this.resizeObserver.disconnect();
          this.isInitialized = false;
        }

        move(direction) {
          const slide = this.track.querySelector('.hiw-learn__slide');
          if (!slide) return;

          const styles = getComputedStyle(this.track);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          const distance = slide.getBoundingClientRect().width + gap;

          this.track.scrollBy({
            left: distance * direction,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        }

        updateControls() {
          const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 1;
          this.controls.hidden = !hasOverflow;

          if (!hasOverflow) return;

          const trackRect = this.track.getBoundingClientRect();
          const slides = this.track.querySelectorAll('.hiw-learn__slide');
          const firstSlide = slides[0];
          const lastSlide = slides[slides.length - 1];
          const tolerance = 2;

          this.previousButton.disabled = firstSlide.getBoundingClientRect().left >= trackRect.left - tolerance;
          this.nextButton.disabled = lastSlide.getBoundingClientRect().right <= trackRect.right + tolerance;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-contact-form"]) return;
  try {
    

  document.getElementById('submitButton').addEventListener('click', function (event) {
    // 检查必填字段
    const requiredFields = ['first-name', 'email', 'city', 'country', 'province', 'subject'];
    for (let field of requiredFields) {
      const input = document.getElementById(field);
      if (!input.value.trim()) {
        // alert(`Please fill out the required field: ${field}`);
        return;
      }
    }
   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.colorScheme =
        document
          .querySelector('main')
          .querySelectorAll('.shopify-section')[0]
          ?.querySelector('[data-header-transparent]')
          ?.getAttribute('data-header-transparent-color-scheme') || '';
      this.isLightLogo =
        document
          .querySelector('main')
          .querySelectorAll('.shopify-section')[0]
          ?.querySelector('[data-header-transparent]')
          ?.getAttribute('data-header-light-logo') || '';

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.isLightLogo == 'true') this.header.classList.add('header--light-logo');
      else this.header.classList.remove('header--light-logo');
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.colorScheme = document
        .querySelector('main')
        .querySelectorAll('.shopify-section')[0]
        ?.querySelector('[data-header-transparent]')
        ?.getAttribute('data-header-transparent-color-scheme');

      if (this.headerIsAlwaysSticky) {
        if (this.header.classList.contains('color-background-overlay')) {
          if (scrollTop > this.header.offsetHeight + 1) {
            this.header.classList.remove('color-background-overlay');
            /*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
            this.header.classList.forEach((className) => {
              if (className.startsWith('color-background-') && className != 'color-background-overlay') {
                this.header.classList.remove(className);
              }
            });
            this.header.classList.add('shopify-section-header-scroll');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (this.header.classList.contains('color-background-overlay-hidden')) {
          if (scrollTop < this.header.offsetHeight) {
            this.header.classList.add('color-background-overlay');
            if (this.colorScheme) this.header.classList.add(this.colorScheme);
            this.header.classList.remove('shopify-section-header-scroll');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-scroll');
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-scroll');
        return;
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        /*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
        this.header.classList.forEach((className) => {
          if (className.startsWith('color-background-') && className != 'color-background-overlay') {
            this.header.classList.remove(className);
          }
        });
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      this.colorScheme = document
        .querySelector('main')
        .querySelectorAll('.shopify-section')[0]
        ?.querySelector('[data-header-transparent]')
        ?.getAttribute('data-header-transparent-color-scheme');
      if (this.headerIsAlwaysSticky) {
        this.header.classList.remove('shopify-section-header-scroll');
        return;
      }
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        this.header.classList.add('color-background-overlay');
        if (this.colorScheme) this.header.classList.add(this.colorScheme);
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (typeof DetailsDisclosure !== 'undefined') {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      if (typeof window.syncProductMediaPopup === 'function') {
        window.syncProductMediaPopup(opener, this);
      }
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retailer-form"]) return;
  try {
    
  document.querySelectorAll('.checkbox-group-store input[type="checkbox"]').forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      const selectedValues = Array.from(
        document.querySelectorAll('.checkbox-group-store input[type="checkbox"]:checked')
      ).map((cb) => cb.value);
      document.getElementById('hiddenInput-store').value = selectedValues.join(', ');
    });
  });

  document.querySelectorAll('.radio-group-market input[type="radio"]').forEach((radio) => {
    radio.addEventListener('change', function () {
      const selectedValues = Array.from(
        document.querySelectorAll('.radio-group-market input[type="radio"]:checked')
      ).map((radio) => radio.value);
      document.getElementById('hiddenInput-market').value = selectedValues.join(', ');
    });
  });

  document.querySelectorAll('.checkbox-group-brand input[type="checkbox"]').forEach((checkbox) => {
    checkbox.addEventListener('change', function () {
      const selectedValues = Array.from(
        document.querySelectorAll('.checkbox-group-brand input[type="checkbox"]:checked')
      ).map((cb) => cb.value);
      document.getElementById('hiddenInput-brand').value = selectedValues.join(', ');
    });
  });

  document.getElementById('submitButton').addEventListener('click', function (event) {
    // 检查必填字段
    const requiredFields = ['first-name', 'email', 'address', 'city', 'country', 'province', 'zip', 'reason'];
    for (let field of requiredFields) {
      const input = document.getElementById(field);
      if (!input.value.trim()) {
        // alert(`Please fill out the required field: ${field}`);
        return;
      }
    }

    const inputStoreValue = document.getElementById('hiddenInput-store').value;
    const inputMarketValue = document.getElementById('hiddenInput-market').value;
    const inputBrandValue = document.getElementById('hiddenInput-brand').value;
    console.log(inputStoreValue + ' -- ' + inputMarketValue + ' -- ' + inputBrandValue);
    if (inputStoreValue === '') {
      event.preventDefault(); // 防止表单提交
      alert('Please select at least one store type option.');
    } else if (inputMarketValue === '') {
      event.preventDefault(); // 防止表单提交
      alert('Please select one market option.');
    /* } else if (inputBrandValue === '') {
      event.preventDefault(); // 防止表单提交
      alert('Please select at least one brand option.'); */
    } else {
    }
  });

  } catch(e) { console.error(e); }
})();
})();
